import { render, staticRenderFns } from "./KittensList.vue?vue&type=template&id=2db1ef02&scoped=true"
import script from "./KittensList.vue?vue&type=script&lang=js"
export * from "./KittensList.vue?vue&type=script&lang=js"
import style0 from "./KittensList.vue?vue&type=style&index=0&id=2db1ef02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1ef02",
  null
  
)

export default component.exports